/**
 * @note: Decorate a string with a prefix and or suffix. In a group of filters, it would be used to decorate the computed value.
 * @description: a very simple general purpose filter to mask a value with a string
 * @example 'process' | prefixSuffix:'pre':'ing' = 'preprocessing'
 * @example '100' | currency:'$':2 | prefixSuffix:'/EA' = '$100.00/EA'
 * @param: {Generic} val - original value
 * @param: {string} prefix
 * @param: {string} suffix
 * @return {Generic | string}
 */

export default function PrefixSuffixFilter() {
  return <T>(val: T, prefix: string = '', suffix: string = ''): string | T => {
    return `${prefix}${val}${suffix}`;
  };
}
